import { RootState } from '../store';

export const selectIsAdminLoginNewDesign = (state: RootState): boolean => state.isAdminNewDesign.isAdminLoginNewDesign;
